export default __webpack_public_path__ + "assets/djibouti-flag.png";